(function ( $ ) {
    $.fn.dateOnlyInput = function() {
        $(this).each(function() {
            const input = $(this);
            input.unbind('keydown.date-only').bind('keydown.date-only', function(event) {
                // check if cmd or control was held
                const isCmdOrCtrl = event.metaKey || event.ctrlKey;
                if (isCmdOrCtrl) {
                    return true;
                }

                const isNumber = !isNaN(event.key);
                const isDash = event.key === '-';
                const isBackspace = event.key === 'Backspace';
                const isDelete = event.key === 'Delete';
                const isArrow = event.key.indexOf('Arrow') === 0;
                const isTab = event.key === 'Tab';
                const isEnter = event.key === 'Enter';

                return isNumber || isDash || isBackspace || isDelete || isArrow || isTab || isEnter;
            });
            input.unbind('keyup.date-only').bind('keyup.date-only', function(event) {
                // Add double digits
                if (event.key === '-') {
                    if (input.val().length === 2) {
                        input.val(`0${input.val()}`);
                    }
                    if (input.val().length === 5) {
                        // input.val() looks like 01-1- but should be 01-01-
                        input.val(`${input.val().substr(0, 3)}0${input.val().substr(3, 1)}${input.val().substr(4, 1)}`);
                    }
                }

                // Insert a dash if the user types a number after the first two digits
                if (input.val().length === 2 && !isNaN(event.key)) {
                    input.val(input.val() + '-');
                }
                // Insert a dash if the user types a number after the first five digits
                if (input.val().length === 5 && !isNaN(event.key)) {
                    input.val(input.val() + '-');
                }
                // // If the last number does not start with a 1 or a 2, add 19 in front of it
                if (input.val().length === 8 && !isNaN(event.key) && input.val().substr(6, 1) !== '1' && input.val().substr(6, 1) !== '2') {
                    input.val(`${input.val().substr(0, 6)}19${input.val().substr(6, 2)}`);
                }
                // Remove double dashes
                if (input.val().indexOf('--') !== -1) {
                    input.val(input.val().replace('--', '-'));
                }
                const value = input.val();
                // Check date format, which should be dd-mm-YYYY, days can't be higher than 31, months can't be higher than 12
                const isValid = value.match(/^\d{2}-\d{2}-\d{4}$/) && value.substr(0, 2) <= 31 && value.substr(3, 2) <= 12;
                input.toggleClass('invalid', !isValid);

                // If the value is < 10, also add the incomplete class
                input.toggleClass('incomplete', value.length < 10);
            }).trigger('keyup.date-only');
        });
        return this;
    };

}( jQuery ));
